


































































import { Component, Vue } from 'vue-property-decorator'
import historyList from '@/components/history/List.vue'
import ffButton from '@/components/public/Button.vue'
@Component({
  components: {
    historyList,
    ffButton
  }
})
export default class HistoryListPage extends Vue {
  activeName = 'processing'
  title: object = {
    'images': 'Images History'
  }
  uploadingList: object[] = []
  completedList: object[] = []
  failedList: object[] = []
  uploadingTotal = 0
  completedTotal = 0
  failedTotal = 0
  pageSize = 30 // 每页展示数
  searchVal = '' // 搜索值
  loading = true // 加载
  reverse = true // 默认倒序
  completePage = 1 // 完成当前激活的页数
  failedPage = 1 // 失败当前激活页码
  progressPage = 1 // 进行当前激活页码
  refresh (): void {
    this.loading = true
    this.togglePage(0, 0) // 进行中的列表刷新状态
  }
  allHistory (): void {
    this['$api'].get(`/all?offset=0&limit=30&reverse=true`).then((res: object) => {
      const data = res['data']
      this.uploadingList = data['uploading']['records']
      this.uploadingTotal = data['uploading']['total']

      this.completedList = data['completed']['records']
      this.completedTotal = data['completed']['total']

      this.failedList = data['failed']['records']
      this.failedTotal = data['failed']['total']

      if (this.uploadingList.length === 0) {
        this.activeName = 'completed'
      }
      this.loading = false
    })
  }
  changePage (page: number): void {
    this.loading = true
    const offset = (page - 1) * 30
    switch (this.activeName) {
      case 'processing':
        this.togglePage(0, offset, this.reverse)
        break
      case 'completed':
        this.togglePage(1, offset, this.reverse)
        break
      case 'failed':
        this.togglePage(2, offset, this.reverse)
        break
      default:
        this.togglePage(1, offset, this.reverse)
        break
    }
  }
  search () {
    this.loading = true
    switch (this.activeName) {
      case 'processing':
        this.progressPage = 1
        this.togglePage(0, 0, this.reverse, this.searchVal)
        break
      case 'completed':
        this.completePage = 1
        this.togglePage(1, 0, this.reverse, this.searchVal)
        break
      case 'failed':
        this.failedPage = 1
        this.togglePage(2, 0, this.reverse, this.searchVal)
        break
      default:
        this.completePage = 1
        this.togglePage(1, 0, this.reverse, this.searchVal)
        break
    }
  }
  togglePage (status: number, offset: number, reverse = true, word?: string): void {
    this['$api'].get('/info', {
      params: {
        status: status,
        offset: offset,
        limit: 30,
        reverse: reverse,
        word: word
      }
    }).then((res: object) => {
      const data = res['data']
      if (status === 0) {
        this.uploadingList = data['records']
        this.uploadingTotal = data['total']
      }
      if (status === 1) {
        this.completedList = data['records']
        this.completedTotal = data['total']
      }
      if (status === 2) {
        this.failedList = data['records']
        this.failedTotal = data['total']
      }
      this.loading = false
    })
  }
  toggleSort (): void {
    this.reverse = !this.reverse
    this.search()
  }
  mounted(): void {
    this.allHistory()
  }
}
